module.exports = __webpack_public_path__ + "media/images/dashcore/logo-e69ebc16679fb507b93b0309d09f2693.png";